<h2 mat-dialog-title>Heads Up!</h2>
<mat-dialog-content class="mat-typography">
  <p *ngIf="data.surveyName.indexOf('WELLNESS') === -1">Are you sure you want to run the automation for {{data.surveyName}} at this time? This would send a message to all Active members. How would you like to proceed?</p>
  <p *ngIf="data.surveyName.indexOf('WELLNESS') > -1">Are you sure to want to run the automation for Running Wellness Data Uploads. Messages could be sent out to users based on the survey automation. How would you like to proceed?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn-success" mat-button [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
  <button class="btn-danger" mat-button [mat-dialog-close]="true">Run Automation</button>
</mat-dialog-actions>
